import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import { ModuleNames } from 'bundles/unified-description-page-common/types/moduleConfig';
import type { ModuleName } from 'bundles/unified-description-page-common/types/moduleConfig';

const EXPERIMENT_NAME = 'xdpAsADiscoveryTool';

export const addXdpAsADiscoveryToolModulesForS12n = (modules: Array<{ name: ModuleName }>) => {
  const copiedModules = [...modules];
  const startIndex = copiedModules.findIndex((module) => module.name === ModuleNames.ArticlesRecommendations);
  const addedModules = [
    {
      name: ModuleNames.DiscoveryRecommendations,
    },
  ];
  copiedModules.splice(startIndex, 1, ...addedModules);
  return copiedModules;
};

export const addXdpAsADiscoveryToolModulesForCourse = (modules: Array<{ name: ModuleName }>) => {
  const copiedModules = [...modules];
  const currentIndex = copiedModules.findIndex((module) => module.name === ModuleNames.Recommendations);
  copiedModules.splice(currentIndex, 1);
  const startIndex = copiedModules.findIndex((module) => module.name === ModuleNames.ArticlesRecommendations);
  const addedModules = [
    {
      name: ModuleNames.Recommendations,
    },
  ];
  copiedModules.splice(startIndex, 1, ...addedModules);
  return copiedModules;
};

export const previewXdpAsADiscoveryToolVariant = () => {
  return GrowthDiscoveryEpicClient.preview(EXPERIMENT_NAME);
};

export const getXdpAsADiscoveryToolVariant = () => {
  return GrowthDiscoveryEpicClient.get(EXPERIMENT_NAME);
};

export const previewIsUserInXdpAsADiscoveryTool = () => {
  return GrowthDiscoveryEpicClient.preview(EXPERIMENT_NAME) !== 'control';
};

export const getIsUserInXdpAsADiscoveryTool = () => {
  return GrowthDiscoveryEpicClient.get(EXPERIMENT_NAME) !== 'control';
};
